import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconChevronRight = createIcon({
  displayName: 'IconChevronRight',
  path: [
    <path
      key="0"
      d="M8.71004 21.71L7.29004 20.29L15.59 12L7.29004 3.71L8.71004 2.29L18.41 12L8.71004 21.71Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
